import { ArrowLeftIcon, ArrowRightIcon, NeuralNetworkIcon, QuoteDownIcon } from 'src/resources/icons/index';
import { Box, Grid2, Typography, useMediaQuery } from '@mui/material';
import theme, { colors } from 'src/theme/theme';

import { FeedBacks } from 'src/resources/data/feedbackdata';
import { StyledAvatar } from 'src/styledComponents/styledAvatar';
import { StyledCircle } from 'src/styledComponents/styledBoxs';
import { StyledNormalButton } from 'src/styledComponents/styledButtons';
import { useState } from 'react';

const FeedbackCard: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [buttonHoverLeft, setButtonHoverLeft] = useState(false);
    const [buttonHoverRight, setButtonHoverRight] = useState(false);
    const totalFeedbacks = FeedBacks.length;
    const { name, designation, feedback, profileImg, linkedinUrl } = FeedBacks[currentIndex];
    const isXXL = useMediaQuery(theme.breakpoints.up('xxl'));
    const iconSize = isXXL ? 55 : 24; // Adjust size for XXL screens

    const handlePrev = (): void => {
        setCurrentIndex((prevIndex) => (prevIndex == 0 ? totalFeedbacks - 1 : prevIndex - 1));
    };
    const handleNext = (): void => {
        setCurrentIndex((prevIndex) => (prevIndex == totalFeedbacks - 1 ? 0 : prevIndex + 1));
    };
    const handleLinkedInClick = (): void => {
        if (linkedinUrl) {
            window.open(linkedinUrl, '_blank');
        }
    };
    return (
        <Box display="flex" flexDirection="column" gap="20px">
            <Box alignItems="center" display="flex" justifyContent="space-between">
                <QuoteDownIcon
                    height={useMediaQuery(theme.breakpoints.up('xxl')) ? 100 : 72}
                    width={useMediaQuery(theme.breakpoints.up('xxl')) ? 100 : 72}
                />
                <Box display="flex" gap="23px">
                    <StyledCircle
                        onClick={handlePrev}
                        onMouseEnter={() => setButtonHoverLeft(true)}
                        onMouseLeave={() => setButtonHoverLeft(false)}
                        sx={{
                            '&:hover': {
                                backgroundColor: 'action.active',
                            },
                            cursor: 'pointer',
                        }}
                    >
                        <ArrowLeftIcon
                            color={buttonHoverLeft ? colors.white : colors.mediumGray}
                            height={iconSize}
                            width={iconSize}
                        />
                    </StyledCircle>
                    <StyledCircle
                        onClick={handleNext}
                        onMouseEnter={() => setButtonHoverRight(true)}
                        onMouseLeave={() => setButtonHoverRight(false)}
                        sx={{
                            '&:hover': {
                                backgroundColor: 'action.active',
                            },
                            cursor: 'pointer',
                        }}
                    >
                        <ArrowRightIcon
                            color={buttonHoverRight ? colors.white : colors.mediumGray}
                            height={iconSize}
                            width={iconSize}
                        />
                    </StyledCircle>
                </Box>
            </Box>

            <Box alignItems="center" py="1rem" textAlign="start">
                <Typography color="grey.500" variant="caption1_Thin">
                    {feedback}
                </Typography>
            </Box>
            <Grid2 alignItems="center" columns={6} container display="flex" gap="1rem" justifyContent="space-between">
                <Grid2 alignItems="center" display="flex" gap="1rem" size={{ lg: 4, md: 4, sm: 4, xs: 6 }}>
                    <StyledAvatar src={profileImg} />
                    <Box display="flex" flexDirection="column" gap="10px">
                        <Typography color="primary.contrastText" variant="body1">
                            {name}
                        </Typography>
                        <Typography color="primary.contrastText" variant="body2_Thin">
                            {designation}
                        </Typography>
                    </Box>
                </Grid2>
                <Grid2 marginLeft={{ md: 'auto' }} size={{ lg: 1, md: 1, sm: 1, xs: 6 }}>
                    <StyledNormalButton
                        endIcon={<NeuralNetworkIcon />}
                        onClick={handleLinkedInClick}
                        sx={{ backgroundColor: 'background.default', ml: 'auto' }}
                    >
                        <Typography color="text.primary" variant="h6_Thin">
                            Social
                        </Typography>
                    </StyledNormalButton>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default FeedbackCard;
